<template>
  <div class="form-field" :class="props.class">
    <label :for="uniqueId" class="form-label" v-html="props.label"></label>
    <div class="field-wrapper">
      <textarea class="form-control" rows="4" v-bind="$attrs" :id="uniqueId" v-model="model"></textarea>
    </div>
  </div>
</template>

<script setup>
import useUniqueId from '../../../directives/uniqueId';

defineOptions({
  inheritAttrs: false
});

const {uniqueId} = useUniqueId();

const props = defineProps({
  class: {
    type: String,
  },
  label: {
    type: String,
    default: 'Informe o label'
  },
});


const model = defineModel({default:''});



</script>
